module.exports = __webpack_public_path__ + "img/es_banner.cf29d0b.gif";